const initFeaturedAwards = () => {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.featured-awards').forEach(section => {
    const slider = section.querySelector('.featured-awards__slider');
    if (!slider) return;

    if (window.innerWidth >= 769) {
        if (slider.swiper) {
            slider.swiper.destroy(true, true);
        }

        slider.dataset.swiperInitialized = 'false';
        return;
    }

    if (section.dataset.mobileSlider === 'false') return;

    if (slider.dataset.swiperInitialized === 'true') return;

    slider.dataset.swiperInitialized = 'true';

    new Swiper(slider, {
      slidesPerView: 2.2,
      spaceBetween: 24,
      loop: false,
      centeredSlides: false,
      watchOverflow: true,
      pagination: {
        el: section.querySelector('.featured-awards__pagination'),
        clickable: true
      },
      breakpoints: {        
        768: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', initFeaturedAwards);
document.addEventListener('shopify:section:load', initFeaturedAwards);
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initFeaturedAwards, 150);
});